module.exports = __webpack_public_path__ + "static/media/leftmf.4f7097be.png";